const apiURL = 'https://foresso-shopify-app.herokuapp.com/api';

const params = new URLSearchParams(window.location.search)
const selectionId = params.has('selection_id') ? params.get('selection_id') : null;

const getItem = (key) => {
  	var data = sessionStorage.getItem(key);
    
  	return (key === 'shape' || key === 'island') ? JSON.parse(data) : data;
}

const setItem = (key, data) => {
  	if (data !== null && typeof data === "object") {
      sessionStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, data);
    }
}

const round = (value, decimals) => {
    return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

const formatToAmount = (amount) => {
  	return amount ? parseFloat(amount.replace(",", "")) : 0;
};

const formatToCurrency = (amount) => {
    const price = round(amount, 2);
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const animateValue = (obj, start, end, duration) => {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        // obj.innerHTML = Math.floor(progress * (end - start) + start);
        obj.innerHTML = formatToCurrency(progress * (end - start) + start);
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

const saveSessionData = () => {
	var formData = $('form#worktop_calc').serializeJSON();
  
    $.each(formData, function(key, data) {
      setItem(key, data);
    });
}

const renderPrice = (total, exclVAT, targetClass) => {
  	$(targetClass).text(formatToCurrency(total));
  	$(targetClass + '_excl').text(formatToCurrency(exclVAT));
  
  	// sidebar total amount
    let itemsTotal = 0;
    $(".worktop_calculator").find(".item_total").each(function() {
      itemsTotal += formatToAmount($(this).text());
    });
    let itemsexclVATTotal = 0;
    $(".worktop_calculator").find(".item_excl_total").each(function() {
      itemsexclVATTotal += formatToAmount($(this).text());
    });
  
    const oldTotal = formatToAmount($("#total").text());
    //animateValue(document.getElementById("total"), oldTotal, itemsTotal, 300);
  	$("#total").text(formatToCurrency(itemsTotal));
	
  	// summary total amount
    $(".overview_total .worktop_total").text(formatToCurrency(itemsTotal));
    $("#excl_vat_amount").text(formatToCurrency(itemsexclVATTotal));
  
  	if(oldTotal !== itemsTotal) changes = true;
  
  	saveSessionData();
}

const getDimensionValue = (shape, dim) => {
  	let dimension = $("#tabs-2 .worktop_select_plan input[name='shape[" + shape + "][" + dim + "]']").val();

  	return dimension ? dimension / 1000 : 0;
}

const parseFormula = (formulaType, shape) => {
    try {
        const shapeData = settings["shapes"][shape];
      	
      	let formulaStr = formulaType === 'shape' ? shapeData[formulaType + "_formula"] : shapeData[formulaType + "_pricings"]["no-walls"];
      
        if(formulaStr) {
          if (formulaStr.indexOf("|A|") > -1) {
              const A = getDimensionValue(shape, 'A');
              formulaStr = formulaStr.replaceAll("|A|", A);
          }

          if (formulaStr.indexOf("|B|") > -1) {
              const B = getDimensionValue(shape, 'B');
              formulaStr = formulaStr.replaceAll("|B|", B);
          }

          return {
              totalFormula: formulaStr.replace(
                  "|MATERIAL|",
                  settings["material"][material]["price"]
              ),
              exclVatFormula: formulaStr.replace(
                  "|MATERIAL|",
                  settings["material"][material]["excl_vat"]
              ),
          };
        } else {
          return null;
        }
    } catch (error) {
        alert(error);
        return null;
    }
}

const materialCalculation = () => {
	const shapeFormula = parseFormula("shape", shape);
  console.log("value=" + shapeFormula);
    if (shapeFormula) {
        const totalPriceFormula = shapeFormula.totalFormula;
        const totalPrice = eval(totalPriceFormula);
      	
      	const exclVatPriceFormula = shapeFormula.exclVatFormula;
        const exclVatPrice = eval(exclVatPriceFormula);

        renderPrice(totalPrice, exclVatPrice, '.material_amount');
    }
}

// Accessories function
const AccessoriesCalculation = () => { 

  const acce_item = $('input[name="accessoriesType"]:checked').val();
  
  if(acce_item == 'no-accessoriesType'){
    $('.accessories_name').text('No Accessories selected');
    renderPrice(0, 0, '.accessories_amount');
  }else{
    var aceess_price = settings["accessories"][acce_item]["price"];
    renderPrice(aceess_price, aceess_price, '.accessories_amount');
  }

}

// Shape functions
const onShapeSelection = () => {
  $('input.ShapeWallType').attr("disabled", false);

  var shapeName = $('input[name="shapeType"]:checked').parent().find(".small_title").text();
  $('.shape_name').html(shapeName);

  var shapeImage = $('input[name="shapeType"]:checked').parent().find("img").attr("src");

  $(".shape_preview_img").attr('src', shapeImage);
  
  updateDimensions();
}

const updateDimensions = () => {
  $(".selected-dimensions").remove();
  
  $(".worktop_select_plan ." + shape + "-wrap .amount_details").each(function() {
    var side = $(this).find(".input-group-text:first").text();
    var value = $(this).find("input").val();
  	$("#invoice_worktop").append('<div class="selected-dimensions"><span>' + side + ':</span><span>' + value + ' mm</span></div>');
  });
}

const validateDimensions = ($element) => {
  var hasError = 0;
  
  $element.parents('.theme-card-wrap').find('input[type=text]').each(function() {
  	var value = $(this).val(),
        shapeType = $(this).data("shape"),
        dimension = $(this).data("dimension");
    
    if(shapeType && dimension) {
      var minDimension = settings["shapes"][shapeType]["min_dimensions"][dimension];
      
      if (value < minDimension) {
        hasError++;
        $('#tabs-2 .worktop_select_plan .' + shapeType + '-wrap .input-error').html("<strong>" + dimension + ":</strong> Minimum " + minDimension + " mm");
      }
    }
  });
  
  if(!hasError) {
    var shapeType = $element.data("shape");
    $('.worktop_select_plan .' + shapeType + '-wrap .input-error').text("");
    
  	$("input:radio[name=materialType][value='" + material + "']").prop("checked", true).change();
    $("input:radio[name=edgeType][value='" + edge + "']").prop("checked", true).change();
    $("input:radio[name=thicknessType][value='" + thickness + "']").prop("checked", true).change();
    
    updateDimensions();
  }
}

// Cut Outs functions
const cutoutCalculation = () => {
  var $qtyTap = $('input[name="cableHoleCutOut"]').val();
  var $qtySink = $('input[name="fixingHoleCutOut"]').val();

  if ($qtyTap > 0 || $qtySink > 0) {
    $(".pselect").addClass("d-none")
  } else {
    $(".pselect").removeClass("d-none")
  }

  if ($qtyTap > 0) {
    $(".tap").removeClass("d-none")
  } else {
    $(".tap").addClass("d-none")
  }

  if ($qtySink > 0) {
    $(".sink").removeClass("d-none")
  } else {
    $(".sink").addClass("d-none")
  }

  var $qtyTapP = parseInt($qtyTap * settings["cableHoleCutOut"]["price"]);
  var $qtyTapExcl = parseInt($qtyTap * settings["cableHoleCutOut"]["excl_vat"]);
  $('input[name="cableHoleCutOut"]').parent().parent().find(".amount_value").html($qtyTapP);
  $('.tap_amount').text($qtyTapP);

  var $qtySinkP = parseInt($qtySink * settings["fixingHoleCutOut"]["price"]);
  var $qtySinkExcl = parseInt($qtySink * settings["fixingHoleCutOut"]["excl_vat"]);
  $('input[name="fixingHoleCutOut"]').parent().parent().find(".amount_value").html($qtySinkP);
  $('.sink_amount').text($qtySinkP);

  var totalPrice = $qtyTapP + $qtySinkP;
  var priceExclVAT = $qtyTapExcl + $qtySinkExcl;
  renderPrice(totalPrice, priceExclVAT, '.cutouts_amount');

  if (totalPrice === 0) {
    $('.cutouts_section').addClass("d-none");
  } else {
    $('.cutouts_section').removeClass("d-none");
  }
}

const setDefaultDimension = () => {
  const shapes = ['rectangle', 'pill', 'circle', 'square'];
  
  shapes.forEach(s => {
    let defaultDimensions = settings["shapes"][s]["default_dimensions"];
    $.each(defaultDimensions, function(key, value) {
   		$("#tabs-2 .worktop_select_plan .theme-card-wrap input[name='shape[" + s + "][" + key + "]']").val(value);
    });
  });
}

const setDefaultData = () => {
  material = "bianco-london-plane";
  edge = "square";
  shape = "rectangle";
  shapeWallType = "no-walls";
  accessoriesType= "no-accessoriesType";
  
  // Set material images
  $("#tabs-1 .materials img.material-image").each(function() {
    var materialName = $(this).attr('alt');
    var card = $(this).parent().parent();
    
    if(settings["material"][materialName]) {
      card.find('.small_title').text(settings["material"][materialName]["colour"]);
      card.find('.sub_title').text(settings["material"][materialName]["wood"]);
      card.find('.amount_value').text(settings["material"][materialName]["price"]);

      $(this).attr("src", settings["material"][materialName]["image"]);
    }
  });

  // Set Accessories images
  $("#tabs-6 .materials img.material-image").each(function() {
    var accessories_Name = $(this).attr('alt');
    var card = $(this).parent().parent();
    
    if(settings["accessories"][accessories_Name]) {
      card.find('.small_title').text(settings["accessories"][accessories_Name]["name"]);
      card.find('.amount_value').text(settings["accessories"][accessories_Name]["price"]);
      $(this).attr("src", settings["accessories"][accessories_Name]["image"]);
    }
  });
  
  // Set edge images
  $("#tabs-3 img.edge-image").each(function() {
    var edgeName = $(this).attr('alt');
    var card = $(this).parent().parent();
    
    card.find('.amount_value').text(settings["edge"][edgeName]["price"]);
    $(this).attr("src", settings["material"][material][edgeName + '_edge_image']);
  });
  
  setDefaultDimension();
  
  $("input:radio[name=shapeType][value='" + shape + "']").prop("checked", true).change();
  $("input:radio[name=materialType][value='" + material + "']").prop("checked", true).change();
  $("input:radio[name=edgeType][value='" + edge + "']").prop("checked", true).change();
  $("input:radio[name=accessoriesType][value='" + accessoriesType + "']").prop("checked", true).change();
}

const setSelectionData = (response) => {
  material = response.materialType;
  edge = response.edgeType;
  shape = response.shapeType;
  
  // Styles
  $("input:radio[name=materialType][value='" + material + "']").prop("checked", true).change();
  $("input:radio[name=edgeType][value='" + edge + "']").prop("checked", true).change();
  
  // Set Shape dimensions
  let shapeDimensions = response['shape'][response.shapeType];
  $.each(shapeDimensions, function(key, value) {
    $("#tabs-2 .worktop_select_plan .theme-card-wrap input[name='shape[" + shape + "][" + key + "]']").val(value);
  });
  $("input:radio[name=shapeType][value='" + shape + "']").prop("checked", true).change();
  
  // Cut outs
  const cutOuts = ['cableHoleCutOut', 'fixingHoleCutOut'];
  cutOuts.forEach(c => {
  	if(response[c] && response[c] > 0) {
      for(var i=1; i<= response[c]; i++) {
      	$("input[name='" + c + "']").parents('.cut_outs_card').find('.card_icons button.plus_icon_svg').click();
      }
    }
  });
}

const getPriceSettings = () => {
	$.ajax({
      type: 'GET',
      dataType: "json",
      url: `${apiURL}/settings?surface_type=tabletop`,
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Accept": "application/json"
      }
    })
    .done(function (response) {
      settings = response;
      setDefaultData();

      const params = new URLSearchParams(window.location.search)
      const selectionId = params.has('selection_id') ? params.get('selection_id') : null;
      
      if(selectionId && customer_email) {
          $.ajax({
            url: `${apiURL}/getSelection`,
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              "Accept": "application/json"
            },
            data: {
              id: selectionId,
              customerId: customer_id
            }
          })
          .done(function (response) {
            $("#worktop_loader").css({opacity: 0, display: "none"});
            setSelectionData(response);
          })
          .fail(function (err) {
            $("#worktop_loader").css({opacity: 0, display: "none"});
            
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `Request failed: ${err.statusText}`
            })
          });
      } else {
      	$("#worktop_loader").css({opacity: 0, display: "none"});
      }
    })
    .fail(function (err) {
      $("#worktop_loader").css({opacity: 0, display: "none"});
      
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `Request failed: ${err.statusText}`
      })
    });
}

const swalPopup = Swal.mixin({
  backdrop: true,
  showClass: {
    popup: '',
  },
  showCloseButton: true,
  showCancelButton: false,
  showConfirmButton: false,
});

const submitQuote = (title, status) => {
  swalPopup.fire({
    title: title,
    input: 'email',
  	inputPlaceholder: 'Enter your email address',
  	inputValue: customer_email,
    inputAttributes: {
      autocapitalize: 'off'
    },
    showLoaderOnConfirm: true,
  	showConfirmButton: true,
    showCancelButton: () => !Swal.isLoading(),
    showCloseButton: () => !Swal.isLoading(),
    allowOutsideClick: () => !Swal.isLoading(),
    confirmButtonText: 'Submit',
    preConfirm: (email) => {
      var formData = $('form#worktop_calc').serializeJSON();
      formData['id'] = selectionId;
      formData['customerId'] = customer_id;
      formData['email'] = email;
      formData['surface_type'] = 'tabletop';
      formData['status'] = status; // status: 1 => Request Invoice, 5 => Email me

      return fetch(`${apiURL}/submitQuote`, {
        method: 'post',
        body: JSON.stringify(formData),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "Accept": "application/json"
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText)
        }
        return response.json();
      })
      .catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`
        )
      })
    }
  }).then((result) => {
    if (result.isConfirmed) {
      if(status === 1) {
      	var modelBody = `<p class="text-italic">What happens next?</p>
        <p>We will review the details and send you an invoice with a payment link.</p>
        <p>Once it’s paid we’ll send you drawings to confirm and then get it scheduled into production.</p>
        <p class="text-italic">When can I expect delivery?</p>
        <p>Every project is unique so we will confirm an estimated delivery date as soon as possible. In the meantime you can check our Lead Time page for current estimates.</p>`;

        swalPopup.fire({
          customClass: {
            container: 'placeOrderConfirmation',
          },
          title: 'Thank you for your order',
          html: modelBody,
          footer: '<div><span class="text-bold">Need some help?</span> <br/> <br/> Check out our <a class="btn-link" href="/pages/faq-contact-us">Help Centre</a>.</div>'
        });
      } else {
        swalPopup.fire({
          icon: 'success',
          title: 'Saved to account!',
          showConfirmButton: true,
          confirmButtonText: 'My account',
        }).then((result) => {
          changes = false;
          if (result.isConfirmed) {
            window.location.href = '/pages/my-worktop-selections';
          }
        });
      }
    }
  });
}

const saveToAccount = () => {
  $("#worktop_loader").css({ opacity: 0.8, display: "flex"});
  
  var formData = $('form#worktop_calc').serializeJSON();
  formData['id'] = selectionId;
  formData['customerId'] = customer_id;
  formData['email'] = customer_email;
  formData['surface_type'] = 'tabletop';
  formData['status'] = 4;

  fetch(`${apiURL}/submitQuote`, {
    method: 'post',
    body: JSON.stringify(formData),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      "Accept": "application/json"
    }
  })
  .then(response => {
    $("#worktop_loader").css({opacity: 0, display: "none"});
    swalPopup.fire({
      icon: 'success',
      title: 'Saved to account!',
      showConfirmButton: true,
      confirmButtonText: 'My account',
    }).then((result) => {
      changes = false;
      if (result.isConfirmed) {
        window.location.href = '/pages/my-worktop-selections';
      }
    });
  })
  .catch(error => {
    $("#worktop_loader").css({opacity: 0, display: "none"});
    swalPopup.fire({
      icon: 'error',
      title: 'Oops...',
      text: error,
      showConfirmButton: true,
      showCloseButton: false,
    });
  })
}

const buyNow = () => {
  $("#worktop_loader").css({opacity: 0, display: "none"});
  var accessories_id;
  
  swalPopup.fire({
    title: 'Buy Now',
    text: 'Enter Quantity',
    input: 'number',
  	inputPlaceholder: 'Quantity',
  	inputValue: 1,
    inputAttributes: {
      min: 1
    },
    inputValidator: (value) => {
        if (!value || value < 1) {
            return 'Please enter a valid quantity!'
        }
    },
    showLoaderOnConfirm: true,
  	showConfirmButton: true,
    showCancelButton: () => !Swal.isLoading(),
    showCloseButton: () => !Swal.isLoading(),
    allowOutsideClick: () => !Swal.isLoading(),
    confirmButtonText: 'Add to cart',
    preConfirm: (quantity) => {
      var formData = $('form#worktop_calc').serializeJSON();
      formData['id'] = selectionId;
      formData['customerId'] = customer_id;
      formData['email'] = customer_email;
      formData['quantity'] = quantity;
      formData['surface_type'] = 'tabletop';
      formData['status'] = 6;

      if(formData['accessoriesType'] == 'maintenance-kit'){
        accessories_id = 41943256531100;
      } else if(formData['accessoriesType'] == 'worktop-oil'){
        accessories_id = 41943259349148;
      } else {
        accessories_id = null;
      }

      return fetch(`${apiURL}/submitQuote`, {
        method: 'post',
        body: JSON.stringify(formData),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "Accept": "application/json"
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText)
        }
        return response.json();
      })
      .catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`
        )
      })
    }
  }).then((result) => {
    if(accessories_id != null){
      var itemsToAdd = [{ quantity: result.value.quantity, id: accessories_id }, { quantity: result.value.quantity, id: result.value.variant_id }];
      var requestData = {
          items: itemsToAdd
      };  
    }else{
      var requestData = { quantity: result.value.quantity, id: result.value.variant_id };
    }
    
    if (result.isConfirmed) {
      if(result.value.variant_id) {
        $("#worktop_loader").css({ opacity: 0.8, display: "flex"});
        
        fetch('/cart/add.js', {
          method: 'post',
          body: JSON.stringify(requestData),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            "Accept": "application/json"
          }
        })
        .then(response => {
          changes = false;
          window.location.href = '/cart';
        })
        .catch(error => {
          $("#worktop_loader").css({opacity: 0, display: "none"});
          
          swalPopup.fire({
            icon: 'error',
            title: 'Oops...',
            text: error,
            showConfirmButton: true,
            showCloseButton: false,
          });
        })
      } else {
        swalPopup.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          showConfirmButton: true,
          showCloseButton: false,
        });
      }
    }
  });
}

//--------------------- IP Configuration -----------------

const ip_configuration = () => {
	$.ajax({
      type: 'GET',
      dataType: "json",
      url: `${apiURL}/ipinfo`,
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Accept": "application/json"
      }
    })
    .done(function (ip_data) {
      console.log(ip_data);
      // var country_code = geoplugin_country_code();
      // console.log("country_code :: 12345", country_code);
      $("#worktop_loader").css({opacity: 0, display: "none"});
      if(ip_data["data"]["geoplugin_countryCode"] == 'UK' || ip_data["data"]["geoplugin_countryCode"] == 'GB'){}
      else{
        $('#buyNowButton').prop('disabled',true); 
        $('#buyNowButton').attr('style','background:grey;cursor:not-allowed;');
      }
      
    })
    .fail(function (err) {
      console.log(err);
    });
}
const ip_configuration_custom = () => {
	     $.ajax({
      type: 'GET',
      dataType: "json",
      url: `${apiURL}/ipinfo`,
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Accept": "application/json"
      }
    })
    .done(function (ip_data) {
      // console.log(ip_data);
      var country_code = geoplugin_country_code();
      console.log("country_code ::", country_code);
      $("#worktop_loader").css({opacity: 0, display: "none"});
      if(country_code == 'UK' || country_code == 'GB'){}
      else{
        $('#buyNowButton').prop('disabled',true); 
        $('#buyNowButton').attr('style','background:grey;cursor:not-allowed;');
      }
      
    })
    .fail(function (err) {
      console.log(err);
    });
}

// ip_configuration();
  setTimeout(() => {
    ip_configuration_custom();
  }, 800);

